module.exports = {
  en: {
    default: true,
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    defaultTitle: `Using i18n with Gatsby`,
    defaultDescription: `Gatsby example site using MDX and dependency-free i18n`,
  },
  ar: {
    path: `ar`,
    locale: `ar-AR`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `ar`,
    ogLanguage: `ar_AR`,
    defaultTitle: `موقع`,
    defaultDescription: `Gatsby Beispielseite, die MDX und i18n (frei von dependencies) nutzt`,
  },
};
